var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3676_15128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 -0.00390625C6.03546 0.00362627 2.44939 2.35159 0.857144 5.98236C-0.735106 9.61312 -0.0330989 13.8416 2.64695 16.7631C4.54089 18.816 7.20686 19.9837 10 19.9837C12.7932 19.9837 15.4591 18.816 17.3531 16.7631C20.0331 13.8416 20.7351 9.61312 19.1429 5.98236C17.5506 2.35159 13.9646 0.00362627 10 -0.00390625ZM10 18.0036C7.92761 18.0004 5.93723 17.1935 4.4477 15.7527C5.37262 13.501 7.5658 12.0309 10 12.0309C12.4342 12.0309 14.6274 13.501 15.5523 15.7527C14.0628 17.1935 12.0724 18.0004 10 18.0036ZM7.99918 7.99943C7.99918 6.8944 8.89498 5.99859 10 5.99859C11.105 5.99859 12.0008 6.8944 12.0008 7.99943C12.0008 9.10446 11.105 10.0003 10 10.0003C8.89498 10.0003 7.99918 9.10446 7.99918 7.99943ZM16.9129 14.0019C16.019 12.473 14.6433 11.2838 13.0013 10.6205C14.4201 9.01173 14.318 6.57035 12.7699 5.08558C11.2218 3.60081 8.77825 3.60081 7.23012 5.08558C5.68199 6.57035 5.57994 9.01173 6.99876 10.6205C5.35668 11.2838 3.98097 12.473 3.08713 14.0019C2.37478 12.7885 1.9984 11.4073 1.99668 10.0003C1.99668 5.58014 5.57989 1.99693 10 1.99693C14.4201 1.99693 18.0033 5.58014 18.0033 10.0003C18.0016 11.4073 17.6252 12.7885 16.9129 14.0019Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3676_15128)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.d6908ddab536ca0064b4c765818f0b82.svg";
export { ForwardRef as ReactComponent };